<template>
	<div>
		<!-- 政策法规 -->
		<el-row class="right-box-row" style="min-height: 430px;" >
			<el-row class="right-box-row-title">
				{{tableTitle}}
			</el-row>
			<el-form :model="zcfgQueryParams" ref="queryForm" :inline="true" style="margin-top: 10px;">
				<el-row class="right-box-row-title-1">
					<el-col :span="20">
						<el-form-item label="业务类型" prop="title">
							<el-link :underline="false" @click="handleQuery('')">全部</el-link>
							<template v-for="(item,index) in typeOptions">
								<el-link :underline="false" @click="handleQuery(item.dictValue)">{{item.dictName}}</el-link>
							</template>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="right-box-row-title">
					<el-col :span="20">
						<el-form-item label="搜索查询" prop="lawName">
							<el-input v-model="zcfgQueryParams.lawName"
									  placeholder="请输入法规政策名称或内容" clearable size="small" />
						</el-form-item>
						<el-button type="primary" style="margin-top: 2px" size="small" @click="getZcfgList">检 索</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table v-loading="zcfgLoading" :data="zcfgTableList" tooltip-effect="light">
				<el-table-column label="序号" type="index" width="50">
				</el-table-column>
				<el-table-column align="left" label="法规政策名称" width="550" :show-overflow-tooltip="true" prop="lawName">
					<template slot-scope="scope">
					   <div align="left"> <span style="cursor: pointer;color: #1e6abc" @click="openPage(scope.row)">{{ scope.row.lawName }}</span></div>
					</template>
				</el-table-column>
				<el-table-column align="left" label="发布单位" :show-overflow-tooltip="true" prop="lawPuborg">
				</el-table-column>
				<el-table-column align="center" label="发布时间" prop="lawPubtime" >
					<template slot-scope="scope">
						<span>{{ parseTime(scope.row.lawPubtime, '{y}-{m}-{d}') }}</span>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="zcfgTotal>0" :total="zcfgTotal" :page.sync="zcfgQueryParams.pageNum"
						:limit.sync="zcfgQueryParams.pageSize" @pagination="getZcfgList" />
		</el-row>
	</div>
</template>

<script>
	import { listMullevel, getListByDictName } from "@/api/law/mullevel/mullevel";
	import {listLaw , lawList ,lawDetail , lawDetailNew ,lawListByYlqx} from "@/api/law/jbxx/law";
	import {updatePvNum} from "@/api/itempv/pv";
	export default {
		name: "Ylqxcx-zcfg",
		props: {
			tableTitle: {
			    type: String,
			    required: true
			},
		},
		data () {
			return {
				zcfgQueryParams:{
					pageNum: 1,
					pageSize: 10,
				},
				zcfgLoading:false,
				zcfgTableList:[],
				zcfgTotal:0,
				typeOptions:[]
			}
		},
		created() {
			getListByDictName({pageNum: 1,pageSize: 10,dictName:'质量提升'}).then(response => {
				let opts = response.rows.filter(data => data.dictValue.indexOf('ylqxcx') != -1);
				this.typeOptions = opts;
				// console.log(opts);
			});
			updatePvNum("zlts_ylqxcx_flfg").then(response => {
			  //pv 点击政策法规
			});
			this.getZcfgList();
		},
		 methods: {
			getZcfgList(){
				this.zcfgLoading = true;
				lawListByYlqx(this.zcfgQueryParams).then(response => {
					this.zcfgTableList = response.rows;
					this.zcfgTotal = response.total;
					this.zcfgLoading = false;
				});
			},
			handleQuery (dictValue) {
				this.zcfgQueryParams.lawRource = dictValue;
				this.getZcfgList();
			},
			openPage(item){
			    this.utils.windowOpen('/main/zltszhfw/ylqxcx/detail/'+item.recid);
			},
		}
	}
</script>

<style scoped>
	.right-box-row {
		border: 1px solid #cccccc;
		padding: 0px 15px 0;
	}
	
	.right-box-row-title {
		padding: 15px 0;
		text-align: left;
		 color: #409eff;
		font-size: 18px;
		font-weight: bold;
		border-bottom: 1px solid #cccccc;
		margin: 0px 0;
	}
	.right-box-row-title-1 {
		/* padding: 15px 0; */
		text-align: left;
		/* color: #409eff; */
		font-size: 18px;
		font-weight: bold;
		/* border-bottom: 1px solid #cccccc; */
		margin: 0;
	}
	
	/deep/.el-form .el-input input {
		width: 25rem;
	}
	
	/deep/ .el-form-item {
		margin-bottom: 0;
	}
	.right-box-row-title-1 /deep/ .el-link--inner {
		margin-right: 20px;
	}
</style>